<template>
	<v-btn v-bind="$attrs" v-on="$listeners" class="cancel-button" depressed>
		<slot />
	</v-btn>
</template>

<script>
export default {
	name: 'CancelButton',
};
</script>

<style scoped lang="scss">
.cancel-button {
	background-color: transparent !important;
	border: 1px solid rgb(147, 161, 187) !important;

	min-width: 215px !important;
	height: 45px !important;
	padding: 0 !important;
	font-size: 14px !important;
	border: 1px solid !important;
	border-radius: 8px !important;
	font-weight: normal !important;

	$no-color: #939baa;
	color: $no-color !important;
	border-color: $no-color !important;
	background: var(--white) !important;
}
</style>
